<template lang="html">
  <b-container v-if="active_group">
    <b-row>
      <b-col>
        <h3>Group administration</h3>
        <h5 class="mt-4">Editing metadata</h5>
        <div
          v-if="approved_email_addresses.length < active_group.user_limit"
          class="col-md-6 mb-5 mt-5"
        >
          <b-form @submit="saveChanges">
            <b-form-group
              id="description-group"
              label="Group description:"
              label-for="description-group-input"
              description="Visible to all members."
            >
              <b-form-input
                id="description-group-input"
                v-model="all_visible_plan_description"
                type="text"
                required
                placeholder="A description of the group"
              />
            </b-form-group>
            <b-form-group
              id="note-group"
              label="A note to group members:"
              label-for="note-group-input"
              description="Additional information visible to group members (optional)."
            >
              <b-form-textarea
                id="note-group-input"
                v-model="user_visible_note"
                type="text"
                rows="6"
                required
                placeholder="Note to users"
              />
            </b-form-group>

            <b-form-group
              id="contact-group"
              label="Billing email address:"
              label-for="contact-group-input"
              description="Who we should contact for invoices and renewal. Not visible to group members."
            >
              <b-form-input
                id="contact-group-input"
                v-model="billing_email"
                type="email"
                required
                placeholder="Enter email"
              />
            </b-form-group>

            <b-btn type="submit" variant="primary">
              Save changes
            </b-btn>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import find from "lodash/find";
import map from "lodash/map";
export default {
  name: "GroupEdit",
  data() {
    return {
      billing_email: "",
      all_visible_plan_description: "",
      user_visible_note: "",
      fields: ["email", "actions"]
    };
  },
  computed: {
    approved_email_addresses() {
      return map(this.active_group.approved_email_addresses, i => {
        return {
          email: i
        };
      });
    },
    active_group() {
      return find(this.$store.state.group_list, { key: this.$route.params.id });
    }
  },
  watch: {
    active_group: {
      handler: function(value) {
        this.populateData(value);
      },
      immediate: true
    }
  },
  methods: {
    populateData(value) {
      if (!value) {
        return;
      }
      this.billing_email = value.billing_email;
      this.all_visible_plan_description = value.all_visible_plan_description;
      this.user_visible_note = value.user_visible_note;
    },
    saveChanges(evt) {
      evt.preventDefault();
      var updateObj = {
        billing_email: this.billing_email,
        all_visible_plan_description: this.all_visible_plan_description,
        user_visible_note: this.user_visible_note,
        id: this.active_group.key
      };
      this.$store.dispatch("updateGroup", updateObj);
      this.$bvToast.toast(`Metadata saved.`, {
        title: "Group updated",
        autoHideDelay: 2000,
        toaster: "b-toaster-top-center",
        variant: "success"
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
